import Drag from '../../drag'

export default class HotspotDrag extends Drag {
  useType = 'make';
  rightKeyMenu = null;
  blockInfo = {
    uuid: '',
    x: 40,
    y: 40,
    width: 40,
    height: 40,
    leftBottomCoordinate: {
      x: 80,
      y: 80
    },
    mislead: false, //  true: 正确答案， false: 错误答案
  };

  /**
   * 
   *   @param {String} plate: 区域類名(.question-design) || body
   *   @param {String} useType: 使用類型。 value: ['make', 'view']. 默认 ‘make’
   *   @param {Object} blockStyle 
   *    style: 方块样式,
   *    selectStyle: 方块选中样式
   *   @param {number | string} maxNum: 允许最多方块 默认10
   */
  constructor(obj) {
    super(obj)

    this.useType = obj.useType || this.useType
    
    this.init()
  }

  init() {
    this.customRightKeyMenu()
    
    // 只有make 才能调用
    this.useType == 'make' && this.findscroller()
  }

  // 调用基類 创建方块
  handleCreateBlock() {
    this.createBlock(node => {
      node.addEventListener('contextmenu', ev => {
        ev.preventDefault()

        let { rightKeyMenu, curBlock } = this
        rightKeyMenu.style.display = 'block'
        rightKeyMenu.style.left = `${ev.pageX}px`
        rightKeyMenu.style.top = `${ev.pageY}px`
        rightKeyMenu.focus()
        
        for(let i = 0; i < rightKeyMenu.childNodes.length; i++) {
          let item = rightKeyMenu.childNodes[i]

          if([...item.classList].indexOf('mislead-choice') > -1) {
            item.innerText = curBlock.mislead ? '设为错误答案' : '设为正确答案';
            break ;
          }
        }
      })
    })
  }

  /**
   * 右键自定义菜单
   */
  customRightKeyMenu() {
    let menu = document.createElement('div')
    menu.setAttribute('class', 'right-key-menu')
    menu.setAttribute('tabindex', '0')
    let singleMenu = [
      {text: '正确', class: 'mislead-choice'},
      {text: '删除', class: 'remove-block'}
    ]

    // 追加子节点
    while(menu.childNodes.length < singleMenu.length) {
      let child = document.createElement('div'),
      item = singleMenu[menu.childNodes.length]
      child.setAttribute('class', `menu-single ${item.class}`)
      child.innerText = item.text

      // 每个按钮增加事件
      if(menu.childNodes.length == 0) child.addEventListener('click', misleadChoice)
      else if(menu.childNodes.length == 1) child.addEventListener('click', removeBlock)

      menu.append(child)
    }

    menu.style.display = 'none'
    document.body.append(menu)
    this.rightKeyMenu = menu

    // 添加失去焦点事件
    menu.addEventListener('blur', () => {
      menu.style.display = 'none'
    })

    //  -------- 子节点事件函數 --------
    let that = this

    // 误导选项
    function misleadChoice () {
      let { curBlock } = that,
      node = document.querySelector(`#${curBlock.uuid}`)
      curBlock.mislead = !curBlock.mislead

      // 添加，移除样式
      if(curBlock.mislead) node.classList.add('correct')
      else node.classList.remove('correct')

      that.rightKeyMenu.blur()
      that.fn(that.blockMap)
    }

    // 移除方块
    function removeBlock() {
      let { uuid } = that.curBlock,
      { plate } = that,
      removeNode = document.querySelector(`#${uuid}`)

      plate.removeChild(removeNode)
      that.blockMap.delete(uuid)
      that.curBlock = {}
      that.rightKeyMenu.blur()

      that.fn(that.blockMap)
    }
  }

  /**
   * 回显视图
   * @param {Array} map 
   */
  echoBlock(map, vue) {
    let { plate, plateObj: { plateClass } } = this, i = 0,
    blockList = document.querySelectorAll(`${plateClass} .block-style`), j = 0,
    status = ['success', 'error', 'click-style'], k;
    
    // 清空
    while(j < blockList.length) {
      plate.removeChild(blockList[j])
      j ++;
    }

    // 追加
    for(;i < map.length; i++) {
      let {width, height, x, y, uuid, style, mislead} = map[i],
      block = document.createElement('div')

      block.setAttribute('class', `block-style ${style}`)
      block.setAttribute('id', uuid)
      block.style = `
        width: ${width}px;
        height: ${height}px;
        top: ${y}px;
        left: ${x}px;
      `
      // 正确答案
      mislead && (block.dataset.mislead = 1)
      // 标记学生点击行为
      block.dataset.mark = -1
     
      // 追加状态节点
      k = 0
      while(k < status.length) {
        let statusNode = document.createElement('div')
        statusNode.setAttribute('class', status[k])

        block.append(statusNode)
        k ++;
      }

      plate.append(block)

      // 添加拖动事件
      this.insertEvent(block, map, vue)
    }
  }

  /**
   * 回显方块 添加事件
   * @param {node} node 
   */
  insertEvent(node) {
    node.onclick = () => {
      let mark = node.dataset.mark
      
      if(mark == -1) {
        node.dataset.mark = 1
        // 更新视图
        node.querySelector('.click-style').style.display = 'block'
      } else {
        node.dataset.mark = -1
        // 更新视图
        node.querySelector('.click-style').style.display = 'none'
      }
    }
  }
}